export default function Phone() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="flex-shrink-0"
    >
      <path
        d="M14.8738 11.5404L16.9627 13.6294C17.2594 13.9261 17.2594 14.4072 16.9627 14.704C15.3583 16.3083 12.8184 16.4888 11.0033 15.1275L10.0802 14.4352C8.36876 13.1516 6.84843 11.6312 5.56483 9.91978L4.87251 8.99668C3.51117 7.18156 3.69168 4.64166 5.29603 3.03731C5.59277 2.74056 6.07389 2.74056 6.37064 3.03731L8.45956 5.12623C8.85008 5.51675 8.85008 6.14992 8.45956 6.54044L7.72645 7.27355C7.59122 7.40878 7.55769 7.61538 7.64322 7.78644C8.63211 9.76421 10.2358 11.3679 12.2136 12.3568C12.3846 12.4423 12.5912 12.4088 12.7265 12.2735L13.4596 11.5404C13.8501 11.1499 14.4832 11.1499 14.8738 11.5404Z"
        fill="#F27021"
        stroke="#F27021"
        strokeWidth="1.2"
      />
    </svg>
  );
}
